export default function Scheduled() {
  return (
    <div className="bg-gray-600 font-bold text-brownu-taupe py-1 px-2 rounded-md">
      SCHEDULED
    </div>
  );
}